import {useEffect, useRef} from 'react';
import {createCheckoutSession} from '../services/CheckoutSession';

export default function useCheckoutSession(scope = 'legacy') {
    const active = useRef(true);
    useEffect(() => {
        active.current = true;
        return () => { active.current = false; };
    }, []);
    return createCheckoutSession(scope, () => active.current);
}
